import { Icon } from '@iconify/react'
import { Button } from './legacy'

export default function CloseButton({ onClickHandler, className = '' }) {
  return (
    <Button
      onClickHandler={onClickHandler}
      variant={'primary'}
      className={className}
      rounded="md"
      size="p-1"
    >
      <Icon icon="ph:x-bold" className={`text-lg`} />
    </Button>
  )
}
